import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import {compact} from "lodash"

import {Mutation} from "../../"
import GetInsGlobal from "../../../client/query/insGlobal"
import GetInsWizard from "../../../client/query/InsWizard"
import GetCustomDriverWizard from "../../../query/wizard/CustomDriver"
import {questionFieldsFragment} from "../../../gql/fragments/question"
import getNewQuestionsRequests from "../../../helpers/question/getNewQuestionsRequests"
import getUpdateQuestionsRequests from "../../../helpers/question/getUpdateQuestionsRequests"
import {insWizardSyncQuestionsMutation} from "../../../client/mutation/insWizardSyncQuestions"

const updateMutation = gql`
  mutation BatchUpdateQuestionsWizard($params: BatchQuestionParamsUpdate!) {
    batchUpdateQuestion(params: $params) {
      ...questionFields
    }
  }
  ${questionFieldsFragment}
`

const createMutation = gql`
  mutation BatchCreateQuestionsWizard($params: BatchQuestionParamsCreate!) {
    batchCreateQuestion(params: $params) {
      ...questionFields
    }
  }
  ${questionFieldsFragment}
`

const BatchSaveQuestions = ({children, onCompleted, onError}) => {
  return (
    <GetCustomDriverWizard useLoader={false}>
      {({driver: {uuid: driverUuid}}) => {
        return (
          <GetInsWizard>
            {({questions, questionGroupId}) => {
              return (
                <GetInsGlobal>
                  {({tenant: tenantUuid, client}) => {
                    const createRequests = getNewQuestionsRequests(questions, tenantUuid, questionGroupId, driverUuid)
                    const updateRequests = getUpdateQuestionsRequests(questions, driverUuid, tenantUuid)
                    const createVariables = {params: {requests: createRequests}}
                    const updateVariables = {params: {requests: updateRequests}}

                    const syncSuccessfulRequests = (response) => {
                      client.mutate({
                        mutation: insWizardSyncQuestionsMutation,
                        variables: {uuids: compact(response).map(({uuid}) => uuid)}
                      })
                    }

                    return (
                      <Mutation
                        mutation={createMutation}
                        variables={createVariables}
                        onError={onError}
                        onCompleted={({batchCreateQuestion}) => {
                          syncSuccessfulRequests(batchCreateQuestion)
                          if (batchCreateQuestion.includes(null)) return onError()
                          return onCompleted()
                        }}>
                        {(create, {loading: createLoading}) => {
                          return (
                            <Mutation
                              onError={onError}
                              mutation={updateMutation}
                              variables={updateVariables}
                              onCompleted={({batchUpdateQuestion}) => {
                                syncSuccessfulRequests(batchUpdateQuestion)
                                if (batchUpdateQuestion.includes(null)) return onError()
                                return (createRequests.length ? create() : onCompleted())
                              }}>
                              {(update, {loading: updateLoading, data, ...apolloState}) => {
                                const handleSave = () => (updateRequests.length ? update() : create())
                                const loading = createLoading || updateLoading
                                return children(handleSave, {loading, ...apolloState})
                              }}
                            </Mutation>
                          )
                        }}
                      </Mutation>
                    )
                  }}
                </GetInsGlobal>
              )
            }}
          </GetInsWizard>
        )
      }}
    </GetCustomDriverWizard>
  )
}

BatchSaveQuestions.propTypes = {
  children: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
  onError: PropTypes.func
}

BatchSaveQuestions.defaultProps = {
  onCompleted: () => null,
  onError: () => null
}

export default BatchSaveQuestions
